import { API_URL_V3 } from 'constants/index';
import { fetch } from 'services/apiV3/fetch';
import { fetchJson } from 'utils/fetchJson/fetchJson';

const kycs = {
  fetch: ({ id }) => {
    const path = `${API_URL_V3}/kycs/${id}`;

    return fetchJson(path);
  },

  fetchByReference: reference => {
    const path = `${API_URL_V3}/kycs/reference/${reference}`;

    return fetchJson(path);
  },

  uploadInfo: (id, fields) => {
    const path = `${API_URL_V3}/kycs/${id}`;
    const body = JSON.stringify({ fields });

    const options = { method: 'PATCH', body };

    return fetchJson(path, options);
  },

  uploadDocument: (file, documentUrl) => {
    const body = new FormData();
    body.append('file', file);

    const path = documentUrl;
    const options = { method: 'POST', body };

    return fetch(path, options);
  },
};

export { kycs };
